
import { defineComponent } from 'vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import useUser from '@/mixins/useUser';

export default defineComponent({
  name: 'BCXMessengerChatBot',
  components: { BCXMarkdown },
  props: {
    name: { type: String, default: '' }
  },
  setup(props) {
    const { tUserFallback: t } = useUser('self');

    return {
      t
    };
  }
});
